<template>
  <div class="air-footer-bar flex jbetween acenter" :class="{ 'sidebar-collapse': $sidebarCollapse, jend }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'airFooterBar',
  props: {
    jend: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.air-footer-bar {
  position: fixed;
  bottom: 0;
  left: 209px;
  width: calc(100vw - 209px);
  height: 60px;
  background: #FFFFFF;
  padding: 0 38px 0 42px;
  box-shadow: 0px -3px 5px 0px rgba(0, 0, 0, 0.08);
  transition: width 0.28s, left 0.28s;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  &.sidebar-collapse {
    left: 59px;
    width: calc(100vw - 59px);
  }
}
</style>
